// extracted by mini-css-extract-plugin
export default {"button":"Ij-z","reviewSort":"Jj-z"};